import React, { useCallback, useEffect, useMemo } from "react";
import PropTypes from "prop-types";
import { useHistory, useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";
import { change, reduxForm } from "redux-form";
import { assignBlankContentFeed } from "reducers/AssignContentFeed";
import { FEED_CREATION_FORM } from "forms/list";
import BaseContentFeedForm from "widgets/forms/contentfeeds/BaseContentFeedForm";
import FeedCreationStepper from "routes/contentfeeds/FeedCreationStepper";
import {
	buildAssignBlankArgs,
	createContentFeedNavigation,
	ASSIGN_BLANK_DEFAULT_VALUES
} from "utils/ContentFeedFormUtils";

import "./ContentFeedCreationSteps.css";

const STEP_NAMES = ["General Settings"];
const VALIDATION_FIELDS = ["feedName", "feedEmails"];

function AssignBlankContentFeedForm({ libraryId, submitting, handleSubmit }) {
	const history = useHistory();
	const location = useLocation();
	const dispatch = useDispatch();

	const assignCreativeIds = location.state?.creativeIds;

	const { goBackToCreativesList, dispatchWithFeedsListRedirect } = useMemo(
		() => createContentFeedNavigation(history, libraryId),
		[history, libraryId]
	);

	// Set default values for assign blank flow
	useEffect(() => {
		dispatch(change(FEED_CREATION_FORM, 'autoMapping', ASSIGN_BLANK_DEFAULT_VALUES.autoMapping));
		dispatch(change(FEED_CREATION_FORM, 'autoUpdates', ASSIGN_BLANK_DEFAULT_VALUES.autoUpdates));
		dispatch(change(FEED_CREATION_FORM, 'sourceUrl', ASSIGN_BLANK_DEFAULT_VALUES.sourceUrl));
		dispatch(change(FEED_CREATION_FORM, 'sourceType', ASSIGN_BLANK_DEFAULT_VALUES.sourceType));
	}, []);

	const handleAssignBlankSave = useCallback((formValues) => {
		const { feedName, email, sourceType, creativeIds, creativeLibraryId } =
			buildAssignBlankArgs(formValues, assignCreativeIds, libraryId);
		return dispatchWithFeedsListRedirect(
			dispatch(assignBlankContentFeed(feedName, email, sourceType, creativeIds, creativeLibraryId))
		);
	}, [assignCreativeIds, libraryId, dispatchWithFeedsListRedirect]);

	const onCancel = useCallback(() => {
		goBackToCreativesList();
	}, []);

	const formProps = {
		onSubmit: handleAssignBlankSave,
		onCancel,
		submitButtonTitle: "Assign Bulk Sheet",
		reduxFormHandleSubmit: handleSubmit,
		isSaveLoading: submitting,
		validationFields: VALIDATION_FIELDS,
		showSourceFields: true,
		showSettingsFields: true,
		isAssignBlankFlow: true,
	};

	return (
		<>
			<FeedCreationStepper stepNames={STEP_NAMES} currentStep={0} />
			<BaseContentFeedForm {...formProps} />
		</>
	);
}

AssignBlankContentFeedForm.propTypes = {
	libraryId: PropTypes.string.isRequired,
	submitting: PropTypes.bool,
	handleSubmit: PropTypes.func.isRequired,
};

export default reduxForm({
	form: FEED_CREATION_FORM,
})(AssignBlankContentFeedForm);
